<template>
<div ref="balancingSection">
  <div class="container-title">
    {{ $t('sale_notes.resumes.balancing') }}
  </div>
  <b-card no-body>
    <b-card-body>
      <div class="row">
        <div class="col-12">
            <b-table-simple class="resume-table" borderless outlined responsive>
              <b-thead>
                <b-tr>
                  <b-td>No</b-td>
                  <b-td>{{ lodash.startCase($t('sale_notes.resumes.product_name')) }}</b-td>
                  <b-td>{{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('sale_notes.resumes.kg')})` }}</b-td>
                  <b-td style="text-align: right">{{ `${lodash.startCase($t('sale_notes.resumes.price'))} (/${$t('sale_notes.resumes.kg')})` }}</b-td>
                  <b-td style="text-align: right; width: 200px">{{ lodash.startCase($t('sale_notes.resumes.amount')) }}</b-td>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="({
                product_name,
                quantity,
                price,
                total_price,
                }, index) in balanceTableItems" :key="index">
                  <b-td>{{ index + 1 }}</b-td>
                  <b-td>{{ lodash.startCase(product_name) }}</b-td>
                  <b-td>{{ decimalFormatter(quantity) }}</b-td>
                  <b-td style="text-align: right">{{ currencyFormatter(price) }}</b-td>
                  <b-td style="text-align: right">{{ currencyFormatter(total_price) }}</b-td>
                </b-tr>
              </b-tbody>
              <b-tfoot>
                <b-tr>
                  <b-td></b-td>
                  <b-td><b>{{ lodash.startCase($t('sale_notes.resumes.sub_total_sales')) }}</b></b-td>
                  <b-td :class="{'text-success': totalBiomass > 0, 'text-danger': totalBiomass < 0}"
                  ><b>{{ `${decimalFormatter(totalBiomass)} ${lodash.startCase($t('units.kg'))}` }}</b></b-td>
                  <b-td></b-td>
                  <b-td
                      :class="{'text-success': totalPrice > 0, 'text-danger': totalPrice < 0}"
                      style="text-align: right"
                  ><b>{{ currencyFormatter(totalPrice) }}</b></b-td>
                </b-tr>
              </b-tfoot>
            </b-table-simple>
        </div>
      </div>
      <div class="row flex-row-reverse balance-summary">
        <div class="col-12 col-md-6 col-xxl-4">
          <b-table-simple class="resume-table balance-summary" outlined borderless>
            <b-tbody>
              <b-tr>
                <b-td v-if="activeTab === 'admin'" style="width: 1%"></b-td>
                <b-th>{{ lodash.startCase($t('sale_notes.resumes.purchased_shrimp')) }}</b-th>
                <b-th style="text-align: right">{{ currencyFormatter(totalShrimp) }}</b-th>
              </b-tr>
              <b-tr>
                <b-td v-if="activeTab === 'admin'"></b-td>
                <b-th>{{ lodash.startCase($t('unloads.singular')) }}</b-th>
                <b-th style="text-align: right">{{ currencyFormatter(totalUnload) }}</b-th>
              </b-tr>
              <b-tr>
                <b-td v-if="activeTab === 'admin'"></b-td>
                <b-th>{{ lodash.startCase($t('sale_notes.resumes.diskon')) }}</b-th>
                <b-th style="text-align: right">{{ currencyFormatter(pph) }}</b-th>
              </b-tr>
              <b-tr v-if="activeTab === 'admin'">
                <b-td v-if="activeTab === 'admin'"></b-td>
                <b-th>{{ lodash.startCase($t('sale_notes.resumes.acceleration_fee')) }}</b-th>
                <b-th style="text-align: right">{{ currencyFormatter(accelerationFee) }}</b-th>
              </b-tr>
              <b-tr v-if="activeTab === 'admin'">
                <b-td v-if="activeTab === 'admin'"></b-td>
                <b-th>{{ lodash.startCase($t('sale_notes.shows.unloading_cost_by_jala')) }}</b-th>
                <b-th style="text-align: right">{{ currencyFormatter(totalExpenseByJala) }}</b-th>
              </b-tr>
              <b-tr>
                <b-td v-if="activeTab === 'admin'"></b-td>
                <b-th>{{ lodash.startCase($t('sale_notes.shows.unloading_cost_by_partner')) }}</b-th>
                <b-th style="text-align: right">{{ currencyFormatter(totalExpenseByPartner) }}</b-th>
              </b-tr>
              <b-tr>
                <b-td v-if="activeTab === 'admin'"></b-td>
                <b-th>{{ lodash.startCase($t('sale_notes.resumes.JALA_margin')) }}</b-th>
                <b-th style="text-align: right">{{ currencyFormatter(jalaMargin) }}</b-th>
              </b-tr>
              <b-tr v-if="partnerDebt == 0">
                <b-th v-if="activeTab === 'admin'"></b-th>
                <b-th :class="{'text-success': partnerMargin > 0, 'text-danger': partnerMargin < 0}">{{ lodash.upperCase($t('sale_notes.resumes.transfer_to_partner')) }}</b-th>
                <b-th :class="{'text-success': partnerMargin > 0, 'text-danger': partnerMargin < 0}" style="text-align: right">{{ currencyFormatter(partnerMargin) }}</b-th>
              </b-tr>
              <b-tr v-if="partnerDebt">
                <b-td v-if="activeTab === 'admin'"></b-td>
                <b-th class="text-danger">{{ lodash.upperCase($t('sale_notes.resumes.partner_debt')) }}</b-th>
                <b-th class="text-danger" style="text-align: right">{{ currencyFormatter(partnerDebt) }}</b-th>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
export default {
  name: 'balance',
  props: {
    value: { type: Object, default: function () { return {} }},
    activeTab: {type: String, default: 'admin'}
  },
  data() {
    return {
      model: this.value,
      partnerMarginVisible: true,
    }
  },
  mounted() {
    if (this.$route.query.section === 'balancing') {
      this.$nextTick(() => this.$refs.balancingSection?.scrollIntoView({ behavior: 'smooth', block: 'start' }))
    }
  },
  computed: {
    harvestShrimpTotal() {
      return Math.abs(this.model?.sales_reports?.filter(({category, sub_category}) => category === 'cost_of_goods_sold' && sub_category === 'harvest').reduce((carry, { total }) => carry + (total ?? 0), 0))
    },
    isKmService () {
      return this.model?.trip?.type === 'deposit_goods'
    },
    iceCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'cost_of_goods_sold' && sub_category === 'ice').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    deliveryCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category === 'delivery').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    labourCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category === 'labour').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    profitShare() {
      return this.value.profit_share?.total ?? 0
    },
    partnerDebt() {
      if (this.value.profit_share.total >= 0) return 0
      return -this.value.profit_share.total
    },
    partnerMargin() {
      return this.value.balancing_transaction?.total_debt ?? 0
    },
    jalaMargin() {
      return this.value?.sale_items?.reduce((carry, { margin }) => carry + margin, 0) ?? 0
    },
    accelerationFee() {
      return -this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'biaya percepatan').reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    pph() {
      return -this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'pph 22').reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    saleItems() {
      return this.value?.sale_items ?? []
    },
    balanceTableItems() {
      return this.model.sale_items.map(({
        quality,
        quantity,
        size,
        unit_price,
        total_price,
      }) => ({
        product_name: `vannamei/${this.qualityFormatter(quality)}/Size ${size}`,
        quantity: quantity,
        price: unit_price,
        total_price: total_price,
      }))
    },
    totalShrimp() {
      let totalItem = this.model?.trip?.trip_items?.reduce((carry, {total_price}) => carry + total_price, 0) ?? 0
      let totalCost = this.model?.trip?.trip_operations?.reduce((carry, {total}) => carry + total, 0) ?? 0
      return totalItem + totalCost
    },
    totalUnload() {
      return this.value?.sale_items?.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0
    },
    totalBiomass() {
      return this.saleItems.reduce((carry, { quantity }) => carry + quantity, 0) ?? 0
    },
    totalPrice() {
      return this.saleItems.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0
    },
    totalExpenseByJala() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category.toLowerCase() === 'paid_by_jala').
          reduce((carry, { total }) => carry + total, 0)
    },
    totalExpenseByPartner() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category === 'expense' && sub_category === 'paid_by_partner').
          reduce((carry, { total }) => carry + total, 0)
    },
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    }
  }
}
</script>

<style lang="scss" scoped>
table.balance-summary {
  margin: 0;
  tbody {
    tr:first-child {
      td, th {
        padding-top: 12px !important;
      }
    }
    tr:last-child {
      td, th {
        padding-bottom: 12px !important;
      }
    }
    td, th {
      padding: 4px 8px;
      background-color: #F9FAFB;
    }
  }
}
</style>